import { PaymentDetailsModel } from './payment-details.model';
import { LineItemsModel } from './line-items.model';
import { OrderSourceModel } from './order-source.model';

export class ConfirmOrderModel {
    lineItems: LineItemsModel[];
    paymentDetails: PaymentDetailsModel;
    ordersource: OrderSourceModel;
}
